import { React, useState, useRef, useEffect } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";
import IconButton from "@mui/material/IconButton";
import CancelIcon from "@mui/icons-material/Cancel";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import Button from "@mui/material/Button";
import { ToastContainer, toast } from "react-toastify";
import { Dropdown } from "semantic-ui-react";
import Tooltip from "@mui/material/Tooltip";
import { Stack } from "@mui/material";
import InputBase from "@mui/material/InputBase";
import Paper from "@mui/material/Paper";
import SearchIcon from "@mui/icons-material/Search";
import Papa from "papaparse";
import MDBadge from "components/MDBadge";
import MDTypography from "components/MDTypography";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import DescriptionIcon from "@mui/icons-material/Description";
import VisibilityIcon from "@mui/icons-material/Visibility";
import colors from "assets/theme/base/colors";
import "../campus/Campus.css";
import Select from "react-select";
import InputMask from "react-input-mask";
import Typography from "@mui/material/Typography";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
import step from "assets/theme/components/stepper/step";
const { info } = colors;
const BASE_URL = process.env.REACT_APP_BASE_URL;
const token = sessionStorage.getItem("token");

const AdmissionCancel = () => {
  const [campaignId, setCampaignId] = useState(null);
  const [form_no, setFormNo] = useState("");
  const [applicant_cnic, setApplicantCnic] = useState("");
  const [all_campaigns, setAllCampaigns] = useState([]);
  const [applications, setApplications] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedApplication, setSelectedApplication] = useState(null);
  const [isCancelling, setIsCancelling] = useState(false);

  const handleCampaignChange = (selected) => {
    setCampaignId(selected ? selected.value : null);
  };

  const fetchAllCampaigns = async () => {
    try {
      const requestOptions = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };
      const response = await fetch(
        BASE_URL + `/campaign/get_campaigns`,
        requestOptions
      );
      const data = await response.json();
      setAllCampaigns(data.campaigns);
    } catch (error) {
      console.log("Error fetching campaigns:", error);
    }
  };

  const fetchApplication = async () => {
    if (!campaignId) {
      toast.error("Please select a campaign.");
      return;
    }
    try {
      let payload = {
        campaign_id: campaignId,
        applicant_cnic: applicant_cnic,
        application_id: form_no,
      };
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      };
      const response = await fetch(
        BASE_URL + `/application/get_selected_applicants_by_form_or_cnic`,
        requestOptions
      );
      const data = await response.json();
      setApplications(data.selected_applicants);
    } catch (error) {
      console.log("Error fetching application:", error);
      toast.error("Error fetching application data.");
    }
  };

  const handleCancelAdmission = (application) => {
    setSelectedApplication(application);
    setIsModalOpen(true);
  };

  const handleConfirmCancel = async () => {
    if (!selectedApplication) {
      return;
    }

    setIsCancelling(true);
    try {
      const payload = {
        application_id: selectedApplication.id,
      };

      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      };

      const response = await fetch(
        BASE_URL + `/application/cancel_admission`,
        requestOptions
      );

      const data = await response.json();

      if (data.success) {
        toast.success("Admission cancelled successfully!");
        fetchApplication(); // Refresh the table
        setIsModalOpen(false);
        setSelectedApplication(null);
      } else {
        toast.error(data.message || "Failed to cancel admission.");
      }
    } catch (error) {
      console.log("Error cancelling admission:", error);
      toast.error("Error cancelling admission.");
    } finally {
      setIsCancelling(false);
    }
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedApplication(null);
  };

  // Prepare data for DataTable
  const prepareTableData = () => {
    const columns = [
      { Header: "Image", accessor: "image", width: "10%" },
      { Header: "Name", accessor: "name", width: "15%" },
      { Header: "CNIC", accessor: "cnic", width: "15%" },
      { Header: "Phone", accessor: "phone", width: "12%" },
      { Header: "Father Name", accessor: "father_name", width: "15%" },
      { Header: "Program", accessor: "program_name", width: "20%" },
      { Header: "Quota", accessor: "quota_name", width: "8%" },
      { Header: "Department", accessor: "department_name", width: "15%" },
      { Header: "Remarks", accessor: "remarks", width: "15%" },
      { Header: "Actions", accessor: "actions", width: "10%" },
    ];

    const rows = applications.map((app) => ({
      image: (
        <MDBox display="flex" alignItems="center">
          <img
            src={app.image || "/default-avatar.png"}
            alt={app.name}
            style={{
              width: "40px",
              height: "40px",
              borderRadius: "50%",
              objectFit: "cover",
            }}
          />
        </MDBox>
      ),
      name: (
        <MDBox display="flex" flexDirection="column">
          <MDTypography variant="caption" fontWeight="medium">
            {app.name}
          </MDTypography>
          <MDTypography variant="caption" color="text" fontWeight="regular">
            Form ID: {app.application_form_id}
          </MDTypography>
        </MDBox>
      ),
      cnic: (
        <MDTypography variant="caption" fontWeight="medium">
          {app.cnic}
        </MDTypography>
      ),
      phone: (
        <MDTypography variant="caption" fontWeight="medium">
          {app.phone}
        </MDTypography>
      ),
      father_name: (
        <MDTypography variant="caption" fontWeight="medium">
          {app.father_name}
        </MDTypography>
      ),
      program_name: (
        <MDTypography variant="caption" fontWeight="medium">
          {app.program_name}
        </MDTypography>
      ),
      quota_name: (
        <MDBadge
          badgeContent={app.quota_name}
          color="info"
          variant="gradient"
          size="sm"
        />
      ),
      department_name: (
        <MDTypography variant="caption" fontWeight="medium">
          {app.department_name}
        </MDTypography>
      ),
      remarks: (
        <MDTypography variant="caption" fontWeight="medium">
          {app.selection_remarks}
        </MDTypography>
      ),
      actions: (
        <MDBox display="flex" alignItems="center">
            {app.is_cancel == false && (
               <Tooltip title="Cancel Admission">
               <IconButton
                 size="small"
                 color="error"
                 onClick={() => handleCancelAdmission(app)}
               >
                 <CancelIcon />
               </IconButton>
             </Tooltip> 
            )}
        </MDBox>
      ),
    }));

    return { columns, rows };
  };

  useEffect(() => {
    fetchAllCampaigns();
  }, []);

  const { columns, rows } = prepareTableData();

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <ToastContainer />
      <MDBox pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <div className="col-md-3">
                <MDTypography variant="subtitle2" fontWeight="light" mb={1}>
                  Campaigns
                </MDTypography>
                <Select
                  name="campaign_id"
                  options={all_campaigns.map((camp) => ({
                    value: camp.id,
                    label: camp.name,
                  }))}
                  className="basic-single-select"
                  classNamePrefix="select"
                  placeholder="Select Campaign"
                  onChange={handleCampaignChange}
                  value={
                    all_campaigns
                      .map((camp) => ({
                        value: camp.id,
                        label: camp.name,
                      }))
                      .find((option) => option.value === campaignId) || null
                  }
                />
              </div>
              <div className="col-md-3">
                <MDTypography variant="subtitle2" fontWeight="light" mb={1}>
                  Form No
                </MDTypography>
                <MDInput
                  type="text"
                  label="Form No"
                  fullWidth
                  value={form_no}
                  onChange={(e) => setFormNo(e.target.value)}
                />
              </div>
              <div className="col-md-3">
                <MDTypography variant="subtitle2" fontWeight="light" mb={1}>
                  CNIC
                </MDTypography>
                <MDInput
                  type="text"
                  label="CNIC"
                  fullWidth
                  value={applicant_cnic}
                  onChange={(e) => setApplicantCnic(e.target.value)}
                />
              </div>
              <div className="col-md-2">
                <MDBox mt={4}>
                  <Button
                    variant="contained"
                    color="primary"
                    style={{ width: "100%", color: "white" }}
                    onClick={fetchApplication}
                  >
                    Fetch Application
                  </Button>
                </MDBox>
              </div>
            </Stack>
          </Grid>

          {/* Display Applications Table */}
          {applications.length > 0 && (
            <Grid item xs={12}>
              <Card>
                <MDBox pt={3} px={3}>
                  <MDTypography variant="h6" fontWeight="medium">
                    Selected Applicants ({applications.length})
                  </MDTypography>
                </MDBox>
                <MDBox pt={1} pb={2} px={3}>
                  <DataTable
                    table={{ columns, rows }}
                    isSorted={false}
                    entriesPerPage={false}
                    showTotalEntries={false}
                    noEndBorder
                  />
                </MDBox>
              </Card>
            </Grid>
          )}

          {/* No Data Message */}
          {applications.length === 0 && (
            <Grid item xs={12}>
              <Card>
                <MDBox pt={3} px={3} pb={3} textAlign="center">
                  <MDTypography variant="h6" fontWeight="light" color="text">
                    No applications found. Please search using campaign, form
                    number, or CNIC.
                  </MDTypography>
                </MDBox>
              </Card>
            </Grid>
          )}
        </Grid>

        {/* Cancel Admission Warning Modal */}
        <Dialog
          open={isModalOpen}
          onClose={handleCloseModal}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle>
            <MDTypography variant="h6" fontWeight="medium" color="error">
              Cancel Admission
            </MDTypography>
          </DialogTitle>
          <DialogContent>
            {selectedApplication && (
              <MDBox mb={3}>
                <MDTypography variant="body1" color="text" mb={2}>
                  Are you sure you want to cancel the admission for:
                </MDTypography>
                <MDBox ml={2} mb={2}>
                  <MDTypography variant="body2" color="text" mb={1}>
                    <strong>Name:</strong> {selectedApplication.name}
                  </MDTypography>
                  <MDTypography variant="body2" color="text" mb={1}>
                    <strong>CNIC:</strong> {selectedApplication.cnic}
                  </MDTypography>
                  <MDTypography variant="body2" color="text" mb={1}>
                    <strong>Form ID:</strong> {selectedApplication.application_form_id}
                  </MDTypography>
                  <MDTypography variant="body2" color="text" mb={1}>
                    <strong>Program:</strong> {selectedApplication.program_name}
                  </MDTypography>
                  <MDTypography variant="body2" color="text" mb={1}>
                    <strong>Department:</strong> {selectedApplication.department_name}
                  </MDTypography>
                </MDBox>
                <MDTypography variant="body2" color="error" fontWeight="medium">
                  Warning: This action cannot be undone!
                </MDTypography>
              </MDBox>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseModal} color="secondary">
              Cancel
            </Button>
            <Button
              onClick={handleConfirmCancel}
              variant="contained"
              color="primary"
              style={{ color: "white" }}
              disabled={isCancelling}
            >
              {isCancelling ? "Cancelling..." : "Yes, Cancel Admission"}
            </Button>
          </DialogActions>
        </Dialog>
      </MDBox>
    </DashboardLayout>
  );
};

export default AdmissionCancel;